import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'angular-highcharts';
import { Canvas, fabric } from 'fabric';
import * as cloneDeep from 'lodash/cloneDeep';
import { Subscription, combineLatest, interval } from 'rxjs';
import {
  CommonService,
  LoadService,
  SiteService
} from 'src/app/services/index';
import {
  BenchSubItemEnum,
  Constants,
  Highcharts$,
  Moment$,
  WarningDialog
} from 'src/app/shared/index';
@Component({
  selector: 'app-testbench-overview',
  templateUrl: './testbench-overview.component.html',
  styleUrls: ['./testbench-overview.component.scss']
})
export class TestbenchOverviewComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('wrapper', { read: ElementRef }) wrapperRef: ElementRef;
  @ViewChild('sensor_trends_chart', { read: ElementRef })
  sensorTrendsChartRef: ElementRef;
  siteId: string;
  title: string;
  description: string;
  testBenchSubItem = BenchSubItemEnum.BenchStatus;
  fromBenchItemSource = BenchSubItemEnum.BenchStatus;
  testBenchData = [];
  testBenchSensorTrend: any;
  testBenchSensorRTData: any;
  selectedTestBenchData: any;
  selectedTestBenchName = '';
  testBenchTimestamp = '';
  testBenchSensorTimestamp = '';
  selectedLoadRID = '';
  loadWithAllNodeDetails: any;
  selectedSensorsCtr = new UntypedFormControl();
  dateRangeCtr = new UntypedFormControl();
  dateRangeRunningCtr = new UntypedFormControl();
  dateRange: any;
  isFirstLoaded = true;
  startDate: string;
  endDate: string;
  alwaysShowCalendars: boolean;
  columnchart: Chart;
  ranges: any = {
    // 'Today': [Moment$(), Moment$()],
    Yesterday: [Moment$().subtract(1, 'days'), Moment$().subtract(1, 'days')],
    'Last 7 Days': [Moment$().subtract(6, 'days'), Moment$()],
    'Last 30 Days': [Moment$().subtract(29, 'days'), Moment$()],
    'This Month': [Moment$().startOf('month'), Moment$().endOf('month')]
    // 'Last Month': [Moment$().subtract(1, 'month').startOf('month'), Moment$().subtract(1, 'month').endOf('month')]
  };
  private subscriptionTestBenchStatusObject: Subscription;
  private subscriptionTestBenchSensorObject: Subscription;
  private aliveTestBenchStatus = true;
  private aliveTestBenchSensor = true;
  private intervallTimer = interval(60 * 2 * 1000);
  private intervallTimerTestBenchSensor = interval(2 * 1000);
  get benchSubItemEnum() {
    return BenchSubItemEnum;
  }
  canvasOriginalWidth: number;
  canvasOriginalHeight = 650;
  canvasWidth: number;
  canvasHeight = 650;
  imgWidth: number;
  imgHeight: 650;
  canvasScaleX = 1;
  canvasScaleY = 1;
  canvas: Canvas;
  canvasGroup: fabric.Group;
  counter = 0; // Only for
  langData: any;
  constructor(
    private siteService: SiteService,
    private loadService: LoadService,
    private activeRoute: ActivatedRoute,
    private commonService: CommonService,
    private renderer: Renderer2,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    public translate: TranslateService
  ) {
    this.title = 'Test Name';
    this.loadWithAllNodeDetails = {};
    // eslint-disable-next-line max-len
    this.loadWithAllNodeDetails.inlets = [
      { name: 'Sensor 1', value: 'Sensor 1' },
      { name: 'Sensor 2', value: 'Sensor 2' },
      { name: 'Sensor 3', value: 'Sensor 3' }
    ];
    this.dateRange = {
      startDate: Moment$().subtract(1, 'days'),
      endDate: Moment$().subtract(1, 'days')
    };
    this.alwaysShowCalendars = true;
    this.subscriptionTestBenchStatusObject = new Subscription();
    this.subscriptionTestBenchSensorObject = new Subscription();
    this.initBenchSensorRTDataObject();
    this.initBenchSensorTrendObject();
    this.translate
      .stream('energy.testbenchOverview')
      .subscribe((subStream: any) => {
        this.langData = subStream;
      });
  }
  ngOnInit() {
    this.getTestBenchStatus();
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
    });
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
    window.addEventListener('resize', this.resizeCanvas);
  }
  ngOnDestroy() {
    this.unSubscriptionInterval(false, false);
  }
  private unSubscriptionInterval = (
    aliveStatus: boolean,
    aliveSensor: boolean
  ) => {
    this.unSubscriptionTestBenchStatus(aliveStatus);
    this.unSubscriptionTestBenchSensor(aliveSensor);
  };
  public getTestBenchStatus = () => {
    this.testBenchSubItem = BenchSubItemEnum.BenchStatus;
    this.unSubscriptionInterval(true, false);
    this.getTestBenchUtilizationTime();
    this.subscriptionTestBenchStatus();
  };
  public getTestBenchImage = (data: any) => {
    this.unSubscriptionInterval(false, true);
    this.testBenchSubItem = BenchSubItemEnum.BenchImage;
    this.selectedTestBenchName = data.displayLoadName;
    this.selectedTestBenchData = data;
    this.selectedLoadRID = data.rId;
    // eslint-disable-next-line max-len
    const json =
      '{"version":"3.4.0","objects":[{"type":"group","version":"3.4.0","originX":"left","originY":"top","left":217,"top":84.8,"width":66,"height":26,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"objects":[{"type":"rect","version":"3.4.0","originX":"left","originY":"top","left":-33,"top":-13,"width":65,"height":25,"fill":"#F9D124","stroke":"blue","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"text","version":"3.4.0","originX":"left","originY":"top","left":-30,"top":-8,"width":20.96,"height":13.56,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"N1","fontSize":12,"fontWeight":"bold","fontFamily":"Bosch-Sans","fontStyle":"normal","lineHeight":1.16,"underline":false,"overline":false,"linethrough":false,"textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}}]},{"type":"group","version":"3.4.0","originX":"left","originY":"top","left":391,"top":157.8,"width":66,"height":26,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"objects":[{"type":"rect","version":"3.4.0","originX":"left","originY":"top","left":-33,"top":-13,"width":65,"height":25,"fill":"#F9D124","stroke":"blue","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"text","version":"3.4.0","originX":"left","originY":"top","left":-30,"top":-8,"width":19.9,"height":13.56,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"N2","fontSize":12,"fontWeight":"bold","fontFamily":"Bosch-Sans","fontStyle":"normal","lineHeight":1.16,"underline":false,"overline":false,"linethrough":false,"textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}}]},{"type":"group","version":"3.4.0","originX":"left","originY":"top","left":646,"top":187.8,"width":66,"height":26,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"objects":[{"type":"rect","version":"3.4.0","originX":"left","originY":"top","left":-33,"top":-13,"width":65,"height":25,"fill":"#F9D124","stroke":"blue","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"text","version":"3.4.0","originX":"left","originY":"top","left":-30,"top":-8,"width":20.25,"height":13.56,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"TFuelTank","fontSize":12,"fontWeight":"bold","fontFamily":"Bosch-Sans","fontStyle":"normal","lineHeight":1.16,"underline":false,"overline":false,"linethrough":false,"textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}}]}],"backgroundImage":{"type":"image","version":"3.4.0","originX":"left","originY":"top","left":0,"top":0,"width":850,"height":650,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"src":"http://localhost:4200/assets/img/ATMO_Img.png","filters":[]}}';
    this.initLoadImageCanvas(json);
  };
  public testBenchTrends = () => {
    this.testBenchSubItem = BenchSubItemEnum.BenchTrends;
    this.unSubscriptionInterval(false, false);
  };
  public getRunningEfficiencyChartForLoad = (fromSource: BenchSubItemEnum) => {
    this.testBenchSubItem = BenchSubItemEnum.BenchRunningEfficiency;
    this.fromBenchItemSource = fromSource;
  };
  public onBack = (item: BenchSubItemEnum) => {
    switch (item) {
      case BenchSubItemEnum.BenchImage:
        this.getTestBenchStatus();
        break;
      case BenchSubItemEnum.BenchTrends:
        this.getTestBenchImage(this.selectedTestBenchData);
        break;
      case BenchSubItemEnum.BenchRunningEfficiency:
        if (this.fromBenchItemSource === BenchSubItemEnum.BenchStatus) {
          this.getTestBenchStatus();
        }
        if (this.fromBenchItemSource === BenchSubItemEnum.BenchImage) {
          if (
            this.commonService.isNullOrUndefined(this.selectedTestBenchData)
          ) {
            this.getTestBenchStatus();
          } else {
            this.getTestBenchImage(this.selectedTestBenchData);
          }
        }
        break;
      default:
        break;
    }
  };
  public generateTestBenchSensorTrends = () => {
    this.drawTestBenchSensorTrendsChart();
  };
  private drawTestBenchSensorTrendsChart = () => {
    this.transformDate();
    //     if(commonService.isAdmin()){
    //       LoadService.getHydraulicRealTimeDataBasedOnNode(params).then(function(data){
    //        drawTestBenchTrends(data);
    //       });
    //     }else{
    //      var dayRange = moment(toDate).diff(moment(fromDate), 'days');
    //      if(dayRange <= 10){
    //         LoadService.getHydraulicRealTimeDataBasedOnNode(params).then(function(data){
    //            drawTestBenchTrends(data);
    //           });
    //       }else{
    //          alert("Note: Data display limited to 10 days. Please select duration not more than 10 days");
    //      }
    //  }
    // Check later, If admin user, allow to select free date range
    if (
      Moment$(this.dateRange.endDate).diff(
        Moment$(this.dateRange.startDate),
        'days'
      ) > 10
    ) {
      this.onOpenAlertBox(this.translate.instant(Constants.DATE_LIMIT_10_DAYS));
    } else {
      // waiting api
      // this.loadService.getHydraulicRealTimeDataBasedOnNode(params).subscribe(data => {

      // });
      this.drawTestBenchTrends(null);
    }
  };
  // Plot Charts Data
  private drawTestBenchTrends = (data: any) => {
    // const option = this.getChartOption
    // this.columnchart = new Chart(<any>option);
    this.sensorTrendsChartRef.nativeElement.innerHTML = '';
    for (let i = 0; i < 3; i++) {
      const div = this.renderer.createElement('div');
      this.renderer.setProperty(div, 'id', 'sensor-trends-chart-' + i);
      this.renderer.appendChild(this.sensorTrendsChartRef.nativeElement, div);

      // Dyamic generate chart based on seleted sensor
      // Testing data
      const sensor = { parameterUnit: 'KW_' + 1, outputType: 'Switch' };
      const dataset = { name: 'Name_' + i, sensor: sensor };
      const option = this.getChartOption(
        dataset,
        'Sub Title',
        false,
        'YAxis Title',
        [],
        [],
        []
      );
      Highcharts$.chart('sensor-trends-chart-' + i, <any>option);
    }
  };
  // parameterUnit = dataset.sensor.parameterUnit
  private getChartOption = (
    dataset: any,
    subTitleText: string,
    showlegend: boolean,
    yAxisTitle: string,
    valveStausCategories: any,
    plotLinesArray: any,
    seriesData: any
  ) => {
    const option = {
      chart: {
        zoomType: 'x',
        spacingTop: 5,
        spacingBottom: 20
      },
      title: {
        text: dataset.name,
        align: 'left',
        margin: 20,
        x: 75,
        style: {
          fontWeight: 'bold',
          fontSize: '20px'
        }
      },
      subtitle: {
        align: 'left',
        margin: 20,
        x: 75,
        text: subTitleText,
        style: { fontSize: '15px' }
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: showlegend
      },
      xAxis: {
        crosshair: true,
        title: {
          text: this.langData.time
        },
        type: 'datetime',
        dateTimeLabelFormats: {
          hour: '%H:%M'
        }
      },
      navigation: {
        buttonOptions: {
          enabled: true
        }
      },
      yAxis: [
        {
          lineWidth: 1,
          title: {
            text: yAxisTitle
          },
          // min: 0,
          labels: {
            formatter: function () {
              // eslint-disable-next-line no-unused-labels
              // fontSize: '55px';
              return this.value + dataset.sensor.parameterUnit;
            }
          },
          categories: valveStausCategories,
          plotLines: plotLinesArray
        }
      ],
      plotOptions: {
        series: {
          marker: {
            enabled: true
          },
          fillOpacity: 0.3,
          type: 'spline',
          turboThreshold: 0,
          threshold: null,
          animation: {
            // Check later
            // duration: $scope.TestBench_SensorTrendsChart_Animation_Duration
          },
          point: {}
        }
      },
      tooltip: {
        shared: true,
        crosshairs: true,
        formatter: function () {
          // EEEE, MMM d, h:mm:ss
          const dateStr = Moment$(this.x).format(
            Constants.MOMENT_DATE_FORMAT.FULL_DATE_TIME_FORMAT
          );
          let toolTipData =
            '<font style="font-size: 10px;">' + dateStr + '</font><br/>';
          let suffix;
          for (let i = 0; i < this.points.length; i++) {
            const myPoint = this.points[i];
            if (
              dataset.sensor.outputType ===
              Constants.HYDRAULIC_OUTPUT_TYPE.Switch
            ) {
              suffix =
                valveStausCategories[this.points[i].point.y] + ' </b> <br>';
            } else {
              suffix =
                this.points[i].point.y +
                ' </b>' +
                dataset.sensor.parameterUnit +
                ' <br>';
            }
            // eslint-disable-next-line max-len
            toolTipData +=
              this.langData.testName +
              ' ' +
              this.points[i].point.info +
              '<br><span style="color:' +
              myPoint.series.color +
              '">\u25CF</span>' +
              myPoint.series.name +
              ': ' +
              suffix;
          }
          return toolTipData;
        }
      },
      series: seriesData
    };
    return option;
  };
  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = description;
  };

  public onChangeDateRange = () => {
    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
  };
  private subscriptionTestBenchStatus = () => {
    this.subscriptionTestBenchStatusObject = this.intervallTimer.subscribe(
      () => {
        if (this.aliveTestBenchStatus) {
          this.getTestBenchUtilizationTime();
        } else {
          if (this.subscriptionTestBenchStatusObject) {
            this.subscriptionTestBenchStatusObject.unsubscribe();
          }
        }
      }
    );
  };
  private subscriptionTestBenchSensor = () => {
    this.subscriptionTestBenchSensorObject =
      this.intervallTimerTestBenchSensor.subscribe(() => {
        if (this.aliveTestBenchSensor) {
          this.getTestBenchLoadWIthsensorData(this.selectedLoadRID);
        } else {
          if (this.subscriptionTestBenchSensorObject) {
            this.subscriptionTestBenchSensorObject.unsubscribe();
          }
        }
      });
  };
  private unSubscriptionTestBenchStatus = (alive: boolean) => {
    if (this.subscriptionTestBenchStatusObject) {
      this.aliveTestBenchStatus = alive;
      this.subscriptionTestBenchStatusObject.unsubscribe();
    }
  };
  private unSubscriptionTestBenchSensor = (alive: boolean) => {
    if (this.subscriptionTestBenchSensorObject) {
      this.aliveTestBenchSensor = alive;
      this.subscriptionTestBenchSensorObject.unsubscribe();
    }
  };
  private getTestBenchUtilizationTime = () => {
    //   LoadService.getTestBenchStatus($scope.TestBenchInfo).then(function(data){
    //     $scope.testBenchData = data;
    //     for(var i=0;i<$scope.testBenchData.length ; i++){
    //       $scope.testBenchData[i].testBench_RunTime = ($scope.testBenchData[i].testBench_RunTime != null ) ? $scope.testBenchData[i].testBench_RunTime.replace(":" , " hrs : ")  + " mins" : null;
    //       $scope.testBenchData[i].testBench_DownTime = ($scope.testBenchData[i].testBench_DownTime != null) ? $scope.testBenchData[i].testBench_DownTime.replace(":" , " hrs : ")+ " mins" : null;
    //       $scope.testBenchData[i].test_RunTime = ($scope.testBenchData[i].test_RunTime != null ) ? $scope.testBenchData[i].test_RunTime.replace(":" , " hrs : ")+ " mins" : null;
    //       $scope.testBenchData[i].loadStateClass = getLoadStateCSSclass($scope.testBenchData[i].loadState);
    //     }
    // $("#testBench_timestamp").html( $filter("date")(new Date(), "dd MMMM yyyy HH:mm:ss"));
    //   });
    this.dumData();
    this.testBenchTimestamp = Moment$().format(
      Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_3
    );
  };
  private getTestBenchLoadWIthsensorData = (loadRId: any) => {
    this.dumBenchSensorRTData();
    this.resizeCanvasAndUpdateValue(true);
    this.counter++; // Only for test
    // Call api get data here
    // this.siteService.getLoadDetail(loadRId).subscribe(data => {
    // Waiting API
    // eslint-disable-next-line max-len
    // if (ObjectUtils.isNullOrUndefined(data.attachments) === false && ObjectUtils.isNullOrUndefined(data.attachments.htmlDivWithLabels) === false) {
    //   const htmlContents = data.attachments.htmlDivWithLabels;
    // }
    // Only for test
    // this.wrapperRef.nativeElement.innerHTML = 'Testing!!! html';
    // dum testBenchSensorRTData
    // this.dumBenchSensorRTData();
    // getHydraulicRealTimeDataBasedOnNode
    // getHydraulicRealTimeData
    // });
  };
  private initLoadImageCanvas = (jsonContent: string) => {
    setTimeout(() => {
      this.canvas = new fabric.Canvas('loadImgCanvas', {
        hoverCursor: 'pointer',
        selection: false,
        selectionBorderColor: 'green',
        backgroundColor: null
      });
      this.setCanvasSize();
      const self = this;
      this.canvas.loadFromJSON(jsonContent, (image: any) => {
        self.canvas.renderAll();
        self.getTestBenchLoadWIthsensorData(this.selectedLoadRID);
        self.subscriptionTestBenchSensor();
      });
    }, 500);
    // const ctx = this.canvas.getContext();
    // const imgObj = new Image();
    // imgObj.src = `data:image/jpeg;base64,${jsonContent}`;
    // imgObj.onload = function() {
    //   ctx.drawImage(imgObj, 0, 0);
    //   const image = new fabric.Image(imgObj);
    //   const options = self.getImageOptions(image);
    //   canvasSelf.setBackgroundImage(image, canvasSelf.renderAll.bind(canvasSelf), options );
    //   canvasSelf.renderAll();
    //   self.updateValuesObjectOnCanvas();
    // };
  };
  private getImageOptions = (image: fabric.Image) => {
    const self = this;
    const canvasAspect = self.canvasWidth / self.canvasHeight;
    const imgAspect = image.width / image.height;
    let scaleX = 0;
    let scaleY = 0;
    // let scaleFactor: number;
    if (canvasAspect >= imgAspect) {
      scaleX = 1;
      scaleY = 1;
    } else {
      scaleX = self.canvasWidth / image.width;
      scaleY = self.canvasHeight / image.height;
    }
    return {
      top: 0,
      left: 0,
      originX: 'left',
      originY: 'top',
      scaleX: scaleX,
      scaleY: scaleY
    };
  };
  private setCanvasSize = (isResized: boolean = false) => {
    // const temp = this.wrapperRef.nativeElement();
    const temp = document.querySelector('#wrapper');
    if (temp) {
      const bcr = temp.getBoundingClientRect();
      this.canvasWidth = bcr.right - bcr.left;
      if (isResized && this.canvasOriginalWidth !== undefined) {
        this.canvasScaleX = this.canvasWidth / this.canvasOriginalWidth;
      }
      this.canvasOriginalWidth = cloneDeep(this.canvasWidth);
      this.canvas.setWidth(this.canvasWidth);
      this.canvas.setHeight(this.canvasHeight);
    }
  };
  private resizeCanvasAndUpdateValue = (isUpdateValue: boolean = false) => {
    if (this.canvas !== undefined && this.canvas.backgroundImage) {
      this.setCanvasSize(true);
      const bi = <fabric.Image>this.canvas.backgroundImage;
      const options = this.getImageOptions(bi);
      bi.scaleX = options.scaleX;
      bi.scaleY = options.scaleY;
      const objects = this.canvas.getObjects();
      for (let i = 0; i < objects.length; i++) {
        const scaleX = objects[i].scaleX;
        const scaleY = objects[i].scaleY;
        const left = objects[i].left;
        const top = objects[i].top;
        const tempScaleX = scaleX * this.canvasScaleX;
        const tempScaleY = scaleY * this.canvasScaleY;
        const tempLeft = left * this.canvasScaleX;
        const tempTop = top * this.canvasScaleY;
        objects[i].scaleX = tempScaleX;
        objects[i].scaleY = tempScaleY;
        objects[i].left = tempLeft;
        objects[i].top = tempTop;
        if (isUpdateValue) {
          const childObjArr = Array.from(objects[i]._objects);
          if (childObjArr.length === 2) {
            // const rect: fabric.Rect = <fabric.Rect>childObjArr[0];
            // const textObj = <any>childObjArr[1];
            // for (let y = 0; y < this.testBenchSensorRTData.Inlet_FlowChannel.length; y++) {
            //   const inlet_FlowChannel = this.testBenchSensorRTData.Inlet_FlowChannel[y];
            //   let nodeText: string = objects[i]._objects[1].text;
            //   if (nodeText.includes(':')) {
            //     nodeText = nodeText.split(':')[0].toString().trim();
            //   }
            //   if (inlet_FlowChannel.name === nodeText) {
            //     // this.canvas.remove(objects[i]);
            //     // this.canvas.renderAll();
            //     const sensor = inlet_FlowChannel.sensor;
            //     const result = `${nodeText}: ${sensor.sensorReading} ${sensor.parameterUnit}`;
            //     // const group = new fabric.Group([rect, text],
            //     //   {selectable: true, subTargetCheck: true}
            //     // );
            //     //this.canvas.add(group);
            //     objects[i]._objects[1].set('text', result);
            //     this.canvas.renderAll();
            //     break;
            //   }
            // }
            let nodeText: string = objects[i]._objects[1].text;
            if (nodeText.includes(':')) {
              nodeText = nodeText.split(':')[0].toString().trim();
            }
            // eslint-disable-next-line max-len
            const index = Array.from(
              this.testBenchSensorRTData.Inlet_FlowChannel
            ).findIndex((value: any) => value.name === nodeText);
            if (index >= 0) {
              const inlet_FlowChannel =
                this.testBenchSensorRTData.Inlet_FlowChannel[index];
              if (inlet_FlowChannel.sensor) {
                const sensor = inlet_FlowChannel.sensor;
                if (this.counter % 2) {
                  sensor.sensorReading = (
                    parseInt(sensor.sensorReading.toString(), 0) + 1
                  ).toString();
                } else {
                  console.log(sensor.sensorReading);
                }
                const result = `${nodeText}: ${sensor.sensorReading} ${sensor.parameterUnit}`;
                objects[i]._objects[1].set('text', result).setCoords();
                // Set blue color for text value
                // let found = false;
                // const charArr = [];
                // cosnt tempObj = new Map<string, any>();
                // if (objects[i]._objects[1]._textLines !== undefined
                //   && objects[i]._objects[1]._textLines.length > 0) {
                //   const tempValue = objects[i]._objects[1]._textLines[0];
                //   for (let z = 0; z < tempValue.length; z++) {
                //     const charValue = tempValue[z];
                //     if (found === false) {
                //       found = charValue === ':';
                //     }
                //     if (found && (charValue !== '' && charValue.trim() !== '' && charValue !== ':')) {
                //          const indexValue = z.toString();
                //         const tempObj = JSON.parse(`{"${indexValue}":{"fill": "blue"}}`);
                //         charArr.push(tempObj);
                //         // tempObj.set(z.toString(), {'fill': 'blue'});
                //     }
                //   }
                //   if (charArr.length > 0) {
                //     const styles = {0: charArr};
                //     const jsonStyles = JSON.stringify(styles);
                //     const te = `{
                //       "0": {
                //         "2": {
                //           "fill": "blue"
                //         },
                //         "3": {
                //           "fill": "blue"
                //         },
                //         "4": {
                //           "fill": "blue"
                //         },
                //         "5": {
                //           "fill": "blue"
                //         }
                //       }
                //     }`;
                //     objects[i]._objects[1].styles = te;
                //   }
                // }
                const text: fabric.Text = <fabric.Text>objects[i]._objects[1];
                objects[i]._objects[0]
                  .set({ width: text.width + 5 })
                  .setCoords();
                // const newObject = cloneDeep(objects[i]);
                // this.canvas.remove(objects[i]);
                // this.canvas.renderAll();
                // this.canvas.add(newObject);
                this.canvas.renderAll();
              }
            }
          }
        }
        objects[i].setCoords();
      }
      this.canvas.renderAll();
      this.canvas.calcOffset();
    }
  };
  private resizeCanvas = () => {
    setTimeout(() => {
      this.resizeCanvasAndUpdateValue();
    }, 700);
  };
  private initBenchSensorRTDataObject = () => {
    this.testBenchSensorRTData = {};
    // this.testBenchSensorRTData.Inlet_FlowChannel = [];
    // this.testBenchSensorRTData.secondaryFlowChannels = [];
  };
  private initBenchSensorTrendObject = () => {
    this.testBenchSensorTrend = {};
    this.testBenchSensorTrend.selectedSensors = [];
    this.testBenchSensorTrend.selectedTests = [];
    this.testBenchSensorTrend.secondarysensorLabels = [];
  };
  private dumData = () => {
    this.testBenchData = [];
    for (let i = 0; i < 15; i++) {
      const obj = {
        displayLoadName: 'ATM0' + i,
        testName: 'ATM0' + i + '_Name',
        testBench_RunTime: Moment$().format(
          Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
        ),
        testBench_DownTime: Moment$().format(
          Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
        ),
        test_RunTime: Moment$().format(
          Constants.MOMENT_DATE_FORMAT.FULL_DATE_FORMAT_1
        ),
        loadStateClass: this.getLoadStateCSSclass(i),
        rId: '#65:2'
      };
      this.testBenchData.push(obj);
    }
  };
  private dumBenchSensorRTData = () => {
    // Copy json file to test here
    this.testBenchSensorRTData = [];
  };
  private getLoadStateCSSclass = (loadState: number): string => {
    let result = '';
    switch (loadState) {
      case 1:
        result = 'fa fa-play-circle item-running';
        break;
      case 2:
        result = 'fa fa-pause-circle item-pause';
        break;
      case 3:
        result = 'fa fa-stop-circle item-stop';
        break;
      case 0:
        result = 'fa fa-exclamation-circle item-exclamation';
        break;
      default:
        result = 'fa fa-exclamation-circle item-exclamation';
        break;
    }
    return result;
  };
  private transformDate = () => {
    this.startDate = Moment$(this.dateRange.startDate).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
    this.endDate = Moment$(this.dateRange.endDate).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
  };
}
